import Image from "next/image";
import { FC } from "react";

type Props = {
  index: number;
  title: string;
  description: string;
  imgSrc: string;
  imgAlt: string;
};

export const PostProjectFlowItem: FC<Props> = ({
  index,
  title,
  description,
  imgSrc,
  imgAlt,
}): JSX.Element => {
  return (
    <article className="flex flex-col items-center laptop:gap-16">
      <div className="flex flex-col items-center justify-center rounded-full bg-yellow-500 w-[120px] h-[120px] leading-none font-bold">
        <span className="text-[24px]">Step</span>
        <span className="text-[60px]">{index}</span>
      </div>

      <div className="relative w-full aspect-square max-w-[300px]">
        <Image className="object-contain" src={imgSrc} alt={imgAlt} fill />
      </div>

      <div className="flex flex-col gap-12">
        <h2 className="text-[24px] font-bold">{title}</h2>
        <p className="text-[20px] leading-loose">{description}</p>
      </div>
    </article>
  );
};
